// extracted by mini-css-extract-plugin
module.exports = {"container":"contact-module--container--1JMah","divider":"contact-module--divider--CU_GG","column":"contact-module--column--3ux83"};